module.exports = __webpack_public_path__ + "img/scrollTo.2dffdbf7.svg";